module.exports = __webpack_public_path__ + "img/chain02.40d14b7d.png";